import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState, useEffect } from "react";
import { useMutation, useLazyQuery } from "@apollo/client";
import { LOGIN, FIND_USER } from "../queries";
import { TextField, Button } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
// Material Kit 2 React examples
//import DefaultFooter from "examples/Footers/DefaultFooter";
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
//import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/strategia.jpg";
//import { set } from "lodash";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
/* eslint-disable react/prop-types */
const LoginForm = ({ setUsertype, setError, setToken, client, selectedKunta }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  const [t] = useTranslation("common");
  const [email, setEmail] = useState("");
  //console.log(setEmail);
  const [password, setPassword] = useState("");
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  const [verified, setVerified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  let logout = useParams().logout;
  //const history = useHistory()
  //const bcryptjs = require("bcryptjs")
  //console.log(token);
  //console.log(setExecuting);
  const [getPerson, resultt] = useLazyQuery(FIND_USER);
  // eslint-disable-next-line
  const [person, setPerson] = useState(null);
  //console.log(setPerson);
  // eslint-disable-next-line
  const showPerson = (email) => {    
    getPerson({
      variables: { emailToSearch: email },
    });
  };
  useEffect(() => {
    if (resultt.data) {
      setUsertype(resultt.data.findUser["type"]);
      localStorage.setItem("usertype", resultt.data.findUser["type"]);
      localStorage.setItem("email", resultt.data.findUser["email"]);
      localStorage.setItem("name", resultt.data.findUser["name"]);
      localStorage.setItem("phone", resultt.data.findUser["phone"]);
      localStorage.setItem("address", resultt.data.findUser["address"]);
      localStorage.setItem("postnumber", resultt.data.findUser["postnumber"]);
      localStorage.setItem("postoffice", resultt.data.findUser["postoffice"]);
      localStorage.setItem("phone", resultt.data.findUser["phone"]);
      localStorage.setItem("datetime", resultt.data.findUser["datetime"]);
      localStorage.setItem("gender", resultt.data.findUser["gender"]);
      localStorage.setItem("born", resultt.data.findUser["born"]);
      localStorage.setItem("municipality", resultt.data.findUser["municipality"]);
      localStorage.setItem("country", resultt.data.findUser["country"]);
      localStorage.setItem("id", resultt.data.findUser["id"]);
      localStorage.setItem("role", resultt.data.findUser["role"]);
      localStorage.setItem("secondarymunicipality", resultt.data.findUser["secondarymunicipality"]);
      localStorage.setItem("secondaryaddress", resultt.data.findUser["secondaryaddress"]);
      localStorage.setItem("secondarypostnumber", resultt.data.findUser["secondarypostnumber"]);
      localStorage.setItem("secondaryrole", resultt.data.findUser["secondaryrole"]);
      /*address: "",
      postnumber: "",
      postoffice: "",
      phone: "",
      activated: true,
      type: "",
      datetime: "",
      acceptedtermsofuse: null,
      gender: null,
      born: null,
      municipality: null,
      country: null,
      locked: false,
      code: "",
      id: "",*/
    }
    // eslint-disable-next-line
  }, [resultt])
  //console.log(person);

  const [login, result] = useMutation(LOGIN, {
    onError: () => {
      setError("virhe");
    },
  });
  // eslint-disable-next-line
  let loggedin = localStorage.getItem("daas-user-token");
  useEffect(() => {
    if (result.data) {
      const token = result.data.login.value;
      //console.log(result.data.login);
      setToken(token);
      localStorage.setItem("daas-user-token", token);
      localStorage.setItem("email", email);
    }
  }, [result.data]) // eslint-disable-line

  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    setVerified(!verified);
  }

  const submit = async () => {
    event.preventDefault();
    //const saltRounds = 17
    //const passwordhash = await bcryptjs.hash(password, saltRounds)
    const passwordhash = password;
    //var salt = bcryptjs.genSaltSync(12)
    //const passwordhash = await bcryptjs.hash(password, salt)
    //console.log(passwordhash);
    // eslint-disable-next-line
    let log = await login({
      variables: { email, passwordhash },
    });
    //console.log(log);
    // eslint-disable-next-line
    let per = await getPerson({
      variables: { email },
    });
    //console.log(per);
    //onLogin("oleppani")
    //history.push("/")
    setSubmitted(true);
  };
  //console.log(logout);
  if (logout === "out") {
    setToken("");
    localStorage.clear();
    client.resetStore();
  }
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  if (submitted) {
    return (
      <>
        <div
          style={{
            left: "10px",
            position: "fixed",
            top: "90px",
            bottom: 0,
            height: "20px",
            color: "#C4DFE6",
            zIndex: 99,
            backgroundColor: "white",
            borderRadius: 90,
            opacity: 0.7,
          }}
          height="20px"
        >
          <div style={divstyle}>
            <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
              <FacebookIcon size={32} round />
            </FacebookShareButton>
          </div>
          <div style={divstyle}>
            <FacebookMessengerShareButton
              url={shareUrl}
              appId="521270401588372"
              className="Demo__some-network__share-button"
            >
              <FacebookMessengerIcon size={32} round />
            </FacebookMessengerShareButton>
          </div>
          <div style={divstyle}>
            <TwitterShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <XIcon size={32} round />
            </TwitterShareButton>
          </div>
          <div style={divstyle}>
            <TelegramShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <TelegramIcon size={32} round />
            </TelegramShareButton>
          </div>
          <div style={divstyle}>
            <WhatsappShareButton
              url={shareUrl}
              title={title}
              separator=":: "
              className="Demo__some-network__share-button"
            >
              <WhatsappIcon size={32} round />
            </WhatsappShareButton>
          </div>
          <div style={divstyle}>
            <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
              <LinkedinIcon size={32} round />
            </LinkedinShareButton>
          </div>
          <div style={divstyle}>
            <EmailShareButton
              url={shareUrl}
              subject={title}
              body="body"
              className="Demo__some-network__share-button"
            >
              <EmailIcon size={32} round />
            </EmailShareButton>
          </div>
          <div style={divstyle}>
            <InstapaperShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <InstapaperIcon size={32} round />
            </InstapaperShareButton>
          </div>
          <div style={divstyle}>
            <ThreadsShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <ThreadsIcon size={32} round />
            </ThreadsShareButton>
          </div>
        </div>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              />
              <br />
              <br />
              <MKTypography variant="body1" textAlign="left" px={{ xs: 6, lg: 12 }} mt={1}>
                {t("common.loginok")}
                <br />
                <br />
                <a href="/">{t("common.tostart")}</a>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  } else {
    return (
      <>
        <div
          style={{
            left: "10px",
            position: "fixed",
            top: "90px",
            bottom: 0,
            height: "20px",
            color: "#C4DFE6",
            zIndex: 99,
            backgroundColor: "white",
            borderRadius: 90,
            opacity: 0.7,
          }}
          height="20px"
        >
          <div style={divstyle}>
            <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
              <FacebookIcon size={32} round />
            </FacebookShareButton>
          </div>
          <div style={divstyle}>
            <FacebookMessengerShareButton
              url={shareUrl}
              appId="521270401588372"
              className="Demo__some-network__share-button"
            >
              <FacebookMessengerIcon size={32} round />
            </FacebookMessengerShareButton>
          </div>
          <div style={divstyle}>
            <TwitterShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <XIcon size={32} round />
            </TwitterShareButton>
          </div>
          <div style={divstyle}>
            <TelegramShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <TelegramIcon size={32} round />
            </TelegramShareButton>
          </div>
          <div style={divstyle}>
            <WhatsappShareButton
              url={shareUrl}
              title={title}
              separator=":: "
              className="Demo__some-network__share-button"
            >
              <WhatsappIcon size={32} round />
            </WhatsappShareButton>
          </div>
          <div style={divstyle}>
            <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
              <LinkedinIcon size={32} round />
            </LinkedinShareButton>
          </div>
          <div style={divstyle}>
            <EmailShareButton
              url={shareUrl}
              subject={title}
              body="body"
              className="Demo__some-network__share-button"
            >
              <EmailIcon size={32} round />
            </EmailShareButton>
          </div>
          <div style={divstyle}>
            <InstapaperShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <InstapaperIcon size={32} round />
            </InstapaperShareButton>
          </div>
          <div style={divstyle}>
            <ThreadsShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <ThreadsIcon size={32} round />
            </ThreadsShareButton>
          </div>
        </div>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 250px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "left",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                <h3>{t("headers.login")}</h3>
              </MKTypography>
              <MKTypography variant="body1" textAlign="left" px={{ xs: 6, lg: 12 }} mt={1}>
                <form onSubmit={submit}>
                  <tr>
                    <td>{t("common.email")}</td>
                    <td>
                      <TextField value={email} onChange={({ target }) => setEmail(target.value)} />
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.password")}</td>
                    <td>
                      <TextField
                        type="password"
                        value={password}
                        onChange={({ target }) => setPassword(target.value)}
                      />
                    </td>
                    <br />
                    <br />
                  </tr>
                  <ReCAPTCHA
                    sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP"
                    onChange={onChange}
                  />
                  <br />
                  <br />
                  <Button
                    variant="contained"
                    style={{
                      fontSize: "14px",
                      color: "white",
                    }}
                    type="submit"
                    disabled={!verified}
                    executing={executing}
                    submitted={submitted}
                  >
                    {submitted ? t("common.done") : executing ? "Verifying" : t("common.login")}
                  </Button>
                  <br />
                  <br />
                  <Link
                    {...{
                      component: RouterLink,
                      to: "/forgetpassword",
                      style: { textDecoration: "none" },
                    }}
                  >
                    {t("common.forgetpassword")}
                  </Link>
                  <br />
                  <br />
                  <Link
                    {...{
                      component: RouterLink,
                      to: "/register",
                      style: { textDecoration: "none" },
                    }}
                  >
                    {t("common.registration")}
                  </Link>
                </form>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
};
export default LoginForm;
